// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getMediaGroupsListFailed, getMediaGroupsListRequested, getMediaGroupsListSucceeded } from './select-media-group.actions';
import { MediaGroupService } from '@par/app/shared/select-media-group/services/media-group.service';

@Injectable()
export class SelectMediaGroupEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getMediaGroupsListRequested),
      mergeMap(() => this.service.getGroups()
        .pipe(
          map((response) => getMediaGroupsListSucceeded({response: response.groups})),
          catchError(() => of(getMediaGroupsListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: MediaGroupService,
  ) {
  }
}
